module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAA1CAYAAAAtf5mbAAAAAXNSR0IArs4c6QAAAIdJREFUaEPt2bENhDAUBcGjA7v/Il0CJxGQEKANkBwM8RP6GjbjGGOcvw2fY/vD1lpbuM05rztuMYe9fBdiNVxixKpA3WuMWBWoe40RqwJ1rzFiVaDuNUasCtS9xohVgbrXGLEqUPcaI1YF6l5jxKpA3WuMWBWoe40RqwJ1/2isvuDr/ba/nv/EqdHxILXKZwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page/crop/five-to-seven.png
// module id = 68fG
// module chunks = 3